import { createDraft } from './draft';

export const internal = {} as {
  createDraft: typeof createDraft;
};
